import { Link } from '@inertiajs/react'

export function LandingFooter() {
  const isHomePage = typeof window !== 'undefined' ? (window.location.pathname === '/' || window.location.pathname === '') : true

  const footerLinks = [
    { label: 'Exams', href: '/exams', isHash: false },
    { label: 'Mock Tests', href: '/mock-tests', isHash: false },
    { label: 'Blog', href: '/blog', isHash: false },
    { label: 'Help', href: '/help', isHash: false },
    { label: 'Privacy', href: '/privacy', isHash: false },
    { label: 'Terms', href: '/terms', isHash: false },
  ]

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, link: { href: string; isHash: boolean }) => {
    if (link.isHash) {
      e.preventDefault()
      const element = document.querySelector(link.href)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  return (
    <footer className="w-full bg-[#131b2e] text-white py-10 border-t border-slate-800">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          
          {/* Logo & Navigation Links */}
          <div className="flex flex-col sm:flex-row items-center gap-6 sm:gap-8">
            <Link
              href="/"
              onClick={(e) => {
                if (isHomePage) {
                  e.preventDefault()
                  if (window.location.hash) {
                    window.history.pushState(null, '', window.location.pathname)
                  }
                  window.scrollTo({ top: 0, behavior: 'smooth' })
                }
              }}
              className="flex items-center gap-2.5 hover:opacity-90 transition-opacity cursor-pointer"
              title="PrepKiya Home"
            >
              <img src="/logo.svg" alt="PrepKiya Logo" className="w-7 h-7 rounded-lg object-contain" />
              <span className="!font-sans font-bold text-lg text-white">
                Prep<span className="text-brand-gold">Kiya</span>
              </span>
            </Link>

            <nav className="flex flex-wrap items-center justify-center sm:justify-start gap-6 sm:gap-8">
              {footerLinks.map((link) => (
                link.isHash ? (
                  <a
                    key={link.label}
                    href={link.href}
                    onClick={(e) => handleLinkClick(e, link)}
                    className="!font-sans text-sm font-medium text-slate-300 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                ) : (
                  <Link
                    key={link.label}
                    href={link.href}
                    className="!font-sans text-sm font-medium text-slate-300 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                )
              ))}
            </nav>
          </div>

          {/* Copyright */}
          <div>
            <span className="!font-sans text-xs text-slate-400">
              &copy; {new Date().getFullYear()} PrepKiya. All rights reserved.
            </span>
          </div>

        </div>
      </div>
    </footer>
  )
}
